import { ButtonRoundSm } from '@apps-common/components/elements'
import { AccountNosModal, ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

export const UnitAccountNoModalButton: React.FC = () => (
  <ModalButton
    component={AccountNosModal}
    disabled={false}
    classes=''
    componentProps={{}}
    enterAnimation={modalSlideUpEnterAnimation}
    leaveAnimation={modalSlideUpLeaveAnimation}
  >
    <ButtonRoundSm
      type='div'
      size='lg'
      className='action-info'
      tooltip={{ id: `devices-account-no-options-tooltip`, message: 'Acc # Options' }}
    >
      <commonIcons.accountNo className='text-[1.05em]' />
    </ButtonRoundSm>
  </ModalButton>
)
